import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import NfcIcon from "@material-ui/icons/Nfc";
import { makeStyles } from "@material-ui/core/styles";
import cookie from 'react-cookie';
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import HeaderBackButton from "./HeaderBackButton";
import HeadsetIcon from "@material-ui/icons/Headset";

//var Router = require("react-router");

const useStyles = makeStyles({
	list: {
		width: 320
	}
});

//var DEBUG32=true;
var DEBUG32=false;


export default function HeaderDrawer(props) {

	//<IconButton>
	//	<NfcIcon />
	//</IconButton>

	//alert(JSON.stringify(props));
	if(DEBUG32) console.log("header props "+JSON.stringify(props));
	if(DEBUG32) console.log(window.location.pathname);
	if(DEBUG32) console.log(window.location.search);

	var strHeaderTitle = "";
            var strHeaderSubTitle = "";

	if (props.headerTitle === undefined || props.headerTitle === null) {
		strHeaderTitle = "더책";
	}
	else {
		strHeaderTitle = props.headerTitle + "";
	}

	if (props.subTitle || props.subTitle === null) {
		if (window.location.pathname.toLowerCase().indexOf("audiobook") > 0 ||
			window.location.search.toLowerCase().indexOf("audiobook") > 0) {
			strHeaderSubTitle = "오디오 라이브러리";
		} else {
			strHeaderSubTitle = "더책";
		};
	}
	else {
		strHeaderSubTitle = props.subTitle + "";
	}

	const classes = useStyles();
	const [state, setState] = React.useState({
		right: false, headerTitle: strHeaderTitle
	});
	
	const toggleDrawer = (side, open) => event => {
		if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
			return;
		}

		setState({ ...state, [side]: open });
	};

	const sideList = side => (
		<div className={classes.list} role="presentation" onKeyDown={toggleDrawer(side, false)}>
			<Sidebar />
		</div>
	);

	let struserid = cookie.load("device_userid");
	var struserdbid = cookie.load("device_userdbid");
	var strorgid = cookie.load("device_orgid");
	var orgname = cookie.load("device_orgname");
	var strorgid2 = cookie.load("general_orgid");
	var orgname2 = cookie.load("general_orgname");
	//let struserid = cookie.load("device_userid");
	//var struserdbid = cookie.load("device_userdbid");
	//var strorgid = cookie.load("device_orgid");
	//var orgname = cookie.load("device_orgname");

	if (typeof (struserdbid) === 'undefined')
		struserdbid = '0';

	if (typeof (strorgid) === 'undefined')
		strorgid = "0";
	if (typeof (orgname) === 'undefined')
		orgname = state.headerTitle;

    if(false) {
            if (typeof (strorgid2) !== 'undefined')
                strorgid = strorgid2;

            if (typeof (orgname2) !== 'undefined')
                orgname = orgname2;
    }


    let strBackInfo = "";
    let subTitle= strHeaderSubTitle;
    
    var strHeaderTitle = <header className='header1'> <h2 className='header1-title'>{subTitle}<HeadsetIcon /></h2> </header>;
    var strHeaderSubTitle = <header className='header1'> <h2 className='header1-title'>{subTitle} </h2> </header>;


	if(DEBUG32) console.log("current_url: " + window.location.pathname);
    if (window.location.pathname !== "/") {
        strBackInfo = <HeaderBackButton />
        strHeaderTitle = "";
    } else {
        strHeaderTitle = "";

    }
    if (orgname === "더책") {
        strHeaderTitle = "";
    }

	let logoimage = "";
	if (strorgid !== "0" && strorgid !== "20" && strorgid !== "2")
	{
		var strlogoimageurl = "/api/AB/getliblogoimage?orgid=" + strorgid;
		logoimage = <a href='/'><img src={strlogoimageurl} className='header-logo'/></a>;
	} else {
		//logoimage="";
		var strlogoimageurl = "/api/AB/getliblogoimage?orgid=" + strorgid;
		logoimage = <a href='/'><img src={strlogoimageurl} className='header-logo'/></a>;
	}

    /*
	return (
		<React.Fragment>
		<div>
	    <header className="header-lsb">
                {strBackInfo}
                    <Link to="/" className="header-title">
                                {logoimage} <span style={{disply:'inlineblock', height:'40px', paddingBottom:'1px', paddingTop:'7px'}}>{orgname}</span> 
                    </Link>
                
                    <div className="header-action">
                        <IconButton onClick={toggleDrawer("right", true)}>
                            <MenuIcon />
                        </IconButton>
                    </div>
            </header>
		<Drawer anchor="right" elevation="0" open={state.right} onClose={toggleDrawer("right", false)}>
			{sideList("right")}
		</Drawer>
		</div>

		<div className="header-tab-lsb">
		    <div className="header-tab-item1 header-tab-active">
			<Link to={"/Home"}> <span className="header-tab-active-text">더책</span> </Link>
		    </div>
		    <div className="header-tab-item2 header-tab-inactive">
			<Link to={"/HomeAudioBook"}> <span className="header-tab-inactive-text">오디오 라이브러리</span> </Link>
		    </div>
        </div>
    
		</React.Fragment>
	);
*/
    return (
        <React.Fragment>
            <div>
                <header className="header-lsb">
                    {strBackInfo}
                    <Link to="/" className="header-title">
                        {logoimage} <span style={{ disply: 'inlineblock', height: '40px', paddingBottom: '1px', paddingTop: '7px' }}>{orgname}</span>
                    </Link>

                    <div className="header-action">
                        <IconButton onClick={toggleDrawer("right", true)}>
                            <MenuIcon />
                        </IconButton>
                    </div>
                </header>
                <Drawer anchor="right" elevation="0" open={state.right} onClose={toggleDrawer("right", false)}>
                    {sideList("right")}
                </Drawer>
            </div>

        </React.Fragment>
    );
}
